import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { _sharedActionsSystem } from "../store/system/actions";
import { isOnLine } from "../utils/user-agent";

const useDetectOnLine = () => {
  const dispatch = useDispatch();

  const setOnline = useCallback((flag) => {
    dispatch(_sharedActionsSystem.setIsOnline(flag));
  }, []);

  useEffect(() => {
    const handleOnLineChange = (onLine) => {
      setOnline(onLine);

      if (!onLine) {
        dispatch(_sharedActionsSystem.toast("@sw:noInternetConnection"));
      }
    };

    const listenerOnline = () => handleOnLineChange(true);
    const listenerOffline = () => handleOnLineChange(false);

    window.addEventListener("online", listenerOnline);
    window.addEventListener("offline", listenerOffline);

    if (global.window?.navigator) {
      handleOnLineChange(isOnLine());
    }

    return () => {
      window.removeEventListener("online", listenerOnline);
      window.removeEventListener("offline", listenerOffline);
    };
  }, [setOnline]);
};

export default useDetectOnLine;
